import { render, staticRenderFns } from "./BulletList.vue?vue&type=template&id=7f164069&scoped=true"
import script from "./BulletList.vue?vue&type=script&lang=js"
export * from "./BulletList.vue?vue&type=script&lang=js"
import style0 from "./BulletList.vue?vue&type=style&index=0&id=7f164069&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f164069",
  null
  
)

export default component.exports